// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"595":"975e9f0a","597":"aed83ba5","942":"f7ac274a"}[chunkId] + ".chunk.js";
};